import { breakpoints } from '@commons/contexts/responsive';

/**
 * Next.js Image `sizes` property for the node card display type.
 *
 * @see https://nextjs.org/docs/app/api-reference/components/image#sizes
 */

export const CARD_DISPLAY_IMAGE_SIZES = `(max-width: ${breakpoints.md}px) 100vw, (max-width: ${breakpoints.lg}) 480px, 560px`;

/**
 * Next.js Image `sizes` property for the node small card display type.
 *
 * @see https://nextjs.org/docs/app/api-reference/components/image#sizes
 */

export const SMALL_CARD_DISPLAY_IMAGE_SIZES = `(max-width: ${breakpoints.md}px) 100vw, (max-width: ${breakpoints.xl}) 320px, 440px`;

/**
 * Next.js Image `sizes` property for the node teaser display type.
 *
 * @see https://nextjs.org/docs/app/api-reference/components/image#sizes
 */

export const TEASER_DISPLAY_IMAGE_SIZES = `(max-width: ${breakpoints.md}px) 100vw, (max-width: ${breakpoints.lg}) 420px, (max-width: ${breakpoints.xl}) 250px, 440px`;

/**
 * Next.js Image `sizes` property for the node featured display type.
 *
 * @see https://nextjs.org/docs/app/api-reference/components/image#sizes
 */

export const FEATURED_DISPLAY_IMAGE_SIZES = `(max-width: ${breakpoints.md}px) 100vw, (max-width: ${breakpoints.lg}) 464px, (max-width: ${breakpoints.xl}) 640px, 864px`;
